/**
 * Confidentialite - Politique de confidentialité (RGPD)
 * Contenu placeholder à valider par un juriste / DPO
 */
import LegalPageLayout from '../components/legal/LegalPageLayout'

export default function Confidentialite() {
  return (
    <LegalPageLayout
      title="Politique de confidentialité"
      lastUpdate="[DATE À DÉFINIR]"
    >
      {/* Section 1 - Introduction */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          1. Introduction
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          La présente politique de confidentialité décrit la manière dont
          [À COMPLÉTER] (« nous », « notre », « RISK-DATA ») collecte, utilise
          et protège les données personnelles des utilisateurs de la plateforme
          RISK-DATA.
        </p>
      </section>

      {/* Section 2 - Responsable de traitement */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          2. Responsable de traitement
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <ul className="list-none space-y-2 text-gray-700">
          <li><strong>Responsable :</strong> [À COMPLÉTER]</li>
          <li><strong>Adresse :</strong> [À COMPLÉTER]</li>
          <li><strong>Contact DPO / RGPD :</strong> [À COMPLÉTER]</li>
        </ul>
      </section>

      {/* Section 3 - Données collectées */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          3. Données collectées
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>

        <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
          3.1 Données de compte
        </h3>
        <ul className="list-disc list-inside space-y-1 text-gray-600">
          <li>Nom et prénom</li>
          <li>Adresse email professionnelle</li>
          <li>Entreprise et fonction</li>
        </ul>

        <h3 className="text-lg font-medium text-gray-800 mt-6 mb-3">
          3.2 Données d'usage
        </h3>
        <ul className="list-disc list-inside space-y-1 text-gray-600">
          <li>Historique de recherche</li>
          <li>Données de connexion (logs)</li>
          <li>Préférences d'utilisation</li>
        </ul>
      </section>

      {/* Section 4 - Finalités et bases légales */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          4. Finalités et bases légales
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-gray-600">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-2 font-medium">Finalité</th>
                <th className="text-left py-2 font-medium">Base légale</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100">
                <td className="py-2">Gestion des comptes utilisateurs</td>
                <td className="py-2">Exécution du contrat</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-2">Amélioration du service</td>
                <td className="py-2">Intérêt légitime</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-2">Sécurité et prévention des fraudes</td>
                <td className="py-2">Intérêt légitime</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-2">Communication commerciale</td>
                <td className="py-2">Consentement</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Section 5 - Durées de conservation */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          5. Durées de conservation
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600">
          <li>Comptes actifs : durée de la relation + 3 ans</li>
          <li>Prospects : 3 ans après le dernier contact</li>
          <li>Logs de connexion : 12 mois</li>
          <li>Données de facturation : 10 ans (obligations légales)</li>
        </ul>
      </section>

      {/* Section 6 - Destinataires */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          6. Destinataires des données
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Vos données peuvent être partagées avec :
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600 mt-2">
          <li>Nos sous-traitants techniques (hébergement, maintenance)</li>
          <li>Les autorités compétentes sur demande légale</li>
        </ul>
      </section>

      {/* Section 7 - Transferts hors UE */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          7. Transferts hors Union européenne
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>

      {/* Section 8 - Droits des personnes */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          8. Vos droits
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Conformément au RGPD, vous disposez des droits suivants :
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600 mt-2">
          <li>Droit d'accès à vos données personnelles</li>
          <li>Droit de rectification</li>
          <li>Droit à l'effacement (« droit à l'oubli »)</li>
          <li>Droit à la limitation du traitement</li>
          <li>Droit à la portabilité des données</li>
          <li>Droit d'opposition</li>
        </ul>
        <p className="text-gray-600 mt-4">
          Pour exercer ces droits, contactez-nous à : [À COMPLÉTER]
        </p>
        <p className="text-gray-600 mt-2">
          Vous pouvez également introduire une réclamation auprès de la CNIL
          (Commission Nationale de l'Informatique et des Libertés).
        </p>
      </section>

      {/* Section 9 - Sécurité */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          9. Sécurité des données
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>

      {/* Section 10 - Modification */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          10. Modification de la politique
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>
    </LegalPageLayout>
  )
}
